import qs from 'qs'

const GET = 'GET'
const POST = 'POST'
const PUT = 'PUT'
const DELETE = 'DELETE'

const buildFetch = (url: string, method: string, params?: URLSearchParams, headers?: any, body?: any): Promise<any> => {
    const options: any = { method, headers: { 'Content-Type': 'application/json' } }

    const link = document.createElement('a')
    link.href = url

    const finalUrl = new URL(link.href)

    if (body) options.body = JSON.stringify(body)
    if (headers) options.headers = { ...options.headers, ...headers }
    if (params) {
        params?.forEach((value, key) => finalUrl.searchParams.append(key, value))
    }

    return fetch(finalUrl.toString(), options).then(response => {
        if (method !== DELETE) {
            return response.json()
        }

        return null
    })
}

export const get = (url: string, params?: URLSearchParams, headers?: any): Promise<any> => {
    return buildFetch(url, GET, params, headers)
}

export const post = (url: string, body: any, headers?: any, params?: URLSearchParams): Promise<any> => {
    return buildFetch(url, POST, params, headers, body)
}

export const put = (url: string, body: any, headers?: any, params?: URLSearchParams): Promise<any> => {
    return buildFetch(url, PUT, params, headers, body)
}

export const remove = (url: string, params?: URLSearchParams, headers?: any): Promise<any> => {
    return buildFetch(url, DELETE, params, headers)
}
